import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import {  REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_ENDPOINT,REACT_APP_KSHEMA_POC2 } from '../urls';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Modal from 'react-bootstrap/Modal';
import { axiosRequest,axiosWithoutToken } from '../service';
import { getCalamityNames, startClaimIntimationImageCoordinatesService,getClaimDocuments } from './apiHelper';
import AsteriskSymbol from '../reusableComponents/AsteriskSymbol';
import { selectedproductName, CONSTANTS, isOtherIntimatorInfoMissing } from '../utilFunctions';
import { animalList, claimIntimatedByOptions, relationshipOptions } from '../consts';
const ClaimWithoutPolicy = (props) => {
  const { cropList, setShowRadioSearch, setOpenDropDown, perilList, productID, setRaiseclaim, claimWithoutPolicyPage,productNames, setClaimWithoutPolicyPage, roleDataCookie, raiseClaim } = props
  const [dateField, setDateField] = useState("")
  const [timeField, setTimeField] = useState("")
  const [addedFiles, setAddedFiles] = useState([])
  const [isFileLoading, setIsFileLoading] = useState(false)
  const [modalShow, setModalShow] = useState(false);
  const [claimID, setClaimID] = useState("")
  const [policyHistory, setPolicyHistory] = useState([])
  const [sortedCauseDate, setSortedCauseDate] = useState(false)
  const [sortedIntimatDate, setSortedIntimatDate] = useState(false)
  const [fileSize, setfileSize] = useState(0);
  const [attachmentType, setAttachmentType] = useState("")
  const [claimDone, setClaimDone] = useState(false);
  const [calamityLabel, setCalamityLabel] = useState("")
  const [policyNumber, setPolicyNumber]=useState('')
  const [validtype, setvalidtype] = useState(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [claimIntimatedBy, setClaimIntimatedBy] = useState(null);
  const [showRelationship, setShowRelationship] = useState(false);
  const [intimatorName, setIntimatorName] = useState("");
  const [relationship, setRelationship] = useState("");
  const ignoreFileKeys = ['PreRegRuleLog', 'PostRegRuleLog','Rejection Letter','CWP Letter', 'Rejection Letter', 'Payout Letter', 'rejection', 'repudiation', 'payment']; // there are system generated json files

  const defaultClaim = {
    policyNumber: "",
    policyCropID: "",
    policyCropName: "",
    policyPerilNames: "",
    policyStatus: "",
    policyStartDate: "",
    policyEndDate: "",
    userID: String(roleDataCookie?.userID),
    policyFarmerID: "",
    policyFarmerName: "",
    policymobilenumber: 0,
    policySurveyNumber: "",
    policyStateID: "",
    policyState: "",
    policyDistrict: "",
    policyMandal: "",
    policyTaluka: "",
    policyVillage: "",
    policyPincode: "",
    policyBlock: "",
    policyBalanceSumInsured: "",
    policyReconciliationStatus: "",
    policyPolygonId: "",
    policySowingDate: "",
    policyAccountNumber: "",
    claimProductID: productID,
    claimType: "",
    claimChannelID: 1,
    claimPerilName: "",
    claimRiskID: 0,
    claimRiskName: "",
    claimDescriptionofLoss: "",
    claimDateAndTimeOfLoss: "",
    claimAlternateMobileNumber: "",
    claimAttachmentType: "",
    claimEstimatedAmount: "",
    claimDocuments: [0],
    tranId:""
  }
  const [claimRequestData, setClaimRequestData] = useState(defaultClaim)
  const [calamityNames, setCalamityNames] = useState([]);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: 'none',
      boxShadow: 'none',
      fontWeight: '500',
      borderBottom: '1px solid #D2D2E4',
      borderRadius: 0,
      width: '95%',
      '&:hover': {
        borderBottom: '1px solid #D2D2E4',
      },
      '& .ms-3__indicator-separator': {
        display: 'none', // Hide the vertical bar
      },
      '& .css-1u9des2-indicatorSeparator': {
        display: 'none', // Hide the vertical bar
      },
    }),
  };

  useEffect(() => {
    getCalamityNames({ setCalamityNames })
  },[])
  const hanldeDatechange = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const dat1 = (date.getDate()).toString().padStart(2, '0')
      setDateField(`${year}-${month}-${dat1}`)
      timeField && timeHandler(timeField, `${year}-${month}-${dat1}`)
    }
  }

  const uploadFile = () => {
    if (isFileLoading) {
      return
    }
    //const file = document.getElementById('fileInput').files[0];
    const fileInput = document.getElementById('fileInput');
    const file = fileInput.files[0];
    if (!file) {
      setIsFileLoading(false);
      return;
    }
    const formData = new FormData();
    if (file) {
      // if((file.size/51200).toFixed(4) > 50){
      //     toast.error("File Size Should be Less Than 50MB.")
      //     return
      // }
      const fileType = file.type;
      //setfileSize(Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize))
      //alert(Number((file.size / (1024 * 1024)).toFixed(4))+Number(fileSize))
      if ((Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize)) > 50) {
        toast.error("File Size Should be Less Than 50MB.")
        setfileSize(Number(fileSize))
        return;
      }
      if (validtype.includes(fileType)) {
        setfileSize((Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize)))
        formData.append('userId', String(roleDataCookie?.userID));
        formData.append('file', file);
        formData.append('docType', "claim");
        formData.append('tranId', raiseClaim?.tran_id);
        setIsFileLoading(true)
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/upload`, formData).then(data => {
          addedFiles.length > 0 ? setAddedFiles([...addedFiles, { name: file.name, id: data.data, size: Number(file.size) }]) : setAddedFiles([{ name: file.name, id: data.data, size: Number(file.size) }])
          toast.success("File Uploaded Successfully.")
          setIsFileLoading(false);
        }).catch(error => {
          console.log(error)
          toast.error("Something Went Wrong.")
        }).finally(() => {
          setIsFileLoading(false);
          fileInput.value = ""; // Clear the file input
        });
      }
      else {
        toast.error("File should be Selected format")
        setIsFileLoading(false)
        fileInput.value = ""; // Clear the file input
        return
      }
    } else {
      setIsFileLoading(false)
    }
  }
  const onRaiseclaim = () => {
    const productName=selectedproductName(productID,productNames)
    if(claimRequestData.claimAttachmentType?.value && addedFiles.length === 0){
      toast.error("Please Upload Attachments.")
      return
    }
    setClaimDone(true)
    const payload = {
      ...claimRequestData,
      claimAttachmentType: claimRequestData?.claimAttachmentType?.value ? claimRequestData?.claimAttachmentType?.value : "",
      claimDateAndTimeOfLoss: dateField + "T" + timeField + ":00",
      claimDocuments: addedFiles.map(list => list.id),
      perilAnimalName: selectedAnimal?.value || "",
      claimIntimatedBy: claimIntimatedBy === "Self" ? "Self" : intimatorName || "",
      claimIntimatedRelationship: relationship || ""
    }
    axiosWithoutToken().post(`${REACT_APP_KSHEMA_POC2}/search`, {
      searchType: CONSTANTS.SEARCH_TYPE_TRANSACTION,
      product: productName.label,
      searchValue: payload.tranId
    }).then(data => {
      if (data.data && data.data !== CONSTANTS.NO_DATA_PRESENT && data.data.length > 0) {
              if(data.data[0].policy_number!= null) {
          payload.policyNumber = data.data[0].policy_number
          payload.policyCropID = data.data[0].crop_id
          payload.policyCropName = data.data[0].crop_name
          payload.policyPerilNames = JSON.stringify(data.data[0].perils)?.replace("[", "")?.replace("]", "")?.replace("'\'", "")?.split(",")?.join(",");
          payload.policyStatus = data.data[0].policy_issuance_status
          payload.policyStartDate = data.data[0].policy_start_date
          payload.policyEndDate = data.data[0].policy_end_Date
          payload.policyFarmerID = data.data[0].farmer_id
          payload.policyFarmerName = data.data[0].customer_name
          payload.policymobilenumber = data.data[0].customer_mobile_number
          payload.policySurveyNumber = data.data[0].survey_number
          payload.policyStateID = data.data[0].policy_state_id
          payload.policyState = data.data[0].policy_state_name
          payload.policyDistrict = data.data[0].policy_district_name
          payload.policyMandal = data.data[0].policy_mandal_name
          payload.policyTaluka = data.data[0].taluka
          payload.policyVillage = data.data[0].policy_village_name
          payload.policyPincode = data.data[0].policy_pincode
          payload.policyBlock = data.data[0].block
          payload.seasonName = data.data[0].season_name
          payload.seasonYear = data.data[0].season_year
          payload.policyBalanceSumInsured = data.data[0].balance_sum_insured
          payload.policyReconciliationStatus = data.data[0].reconciliation_status
          payload.policyPolygonId = data.data[0].customer_polygon
          payload.policySowingDate =  data.data[0].sowing_date
          payload.policyAccountNumber = data.data[0].account_number
          payload.policyIssuanceDate = data.data[0].policy_issuance_date
          payload.cultivatedArea = data.data[0].cultivated_area
          payload.policyDuration = data.data[0].policy_duration
        }
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/generateClaim`, payload).then(async data => {
         setClaimID(data.data.claimNo)
         const response= getClaimDocuments(data.data.claimNo)
         const images =response.data?.filter((item)=>!ignoreFileKeys.includes(item.docType)).map(item => item.docName);
          setClaimDone(false)
          // setRaiseclaim(null)
          setModalShow(true)
          await startClaimIntimationImageCoordinatesService(data?.data?.claimNo,images);
        }).catch(error => {
          console.log(error)
          toast.error("Something Went Wrong.")
          setClaimDone(false);
        })
            }  else {
        setClaimDone(false)
        toast.error("Please enter valid transaction id")
      }
    }).catch(error => {
      console.error(error)
    })
  }

  const sortCauseDates = () => {
    let sortedDates = []
    if (sortedCauseDate) {
      sortedDates = policyHistory.sort(function (a, b) {
        return new Date(b.dateAndTimeOfLoss) - new Date(a.dateAndTimeOfLoss)
      });
      setSortedCauseDate(false)
    } else {
      sortedDates = policyHistory.sort(function (a, b) {
        return new Date(a.dateAndTimeOfLoss) - new Date(b.dateAndTimeOfLoss)
      });
      setSortedCauseDate(true)
    }
    setPolicyHistory([...sortedDates])
  }
  const sortIntimateDates = () => {
    let sortedDates = []
    if (sortedIntimatDate) {
      sortedDates = policyHistory.sort(function (a, b) {
        return new Date(b.claimOpenDate) - new Date(a.claimOpenDate)
      });
      setSortedIntimatDate(false)
    } else {
      sortedDates = policyHistory.sort(function (a, b) {
        return new Date(a.claimOpenDate) - new Date(b.claimOpenDate)
      });
      setSortedIntimatDate(true)
    }
    setPolicyHistory([...sortedDates])
  }
  const timeHandler = (time, date) => {
    let dateNewField = date ? date : dateField
    if (new Date().setHours(0, 0, 0, 0) == new Date(dateNewField).setHours(0, 0, 0, 0)) {
      var d = new Date(); // for now
      d.getHours(); // => 9
      d.getMinutes();
      let str1 = time
      let str2 = String(d.getHours() + ":" + d.getMinutes())
      str1 = str1.split(':');
      str2 = str2.split(':');

      const totalSeconds1 = Number(str1[0] * 3600 + str1[1] * 60);
      const totalSeconds2 = Number(str2[0] * 3600 + str2[1] * 60);
      if (totalSeconds1 > totalSeconds2) {
        toast.error("Date & Time of Peril Occurrence Can't be Future Date & Time.")
        setTimeField("")
      } else {
        setTimeField(time)
      }
    } else {
      setTimeField(time)
    }

  }

  const isDisabled = isOtherIntimatorInfoMissing(claimIntimatedBy, intimatorName, relationship);

  return (
    <section className="p-4">
      <h5>Policy Details</h5>
      <div>
        <div className="outer-boxPolicy">
          <div className="inner-boxPolicy" style={{ height: "500px" }}>
            <h3 id="new_claimPolicy">New Claim Details</h3>
            <div>
              <div className="row mt-5">
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                  <p className="align3Policy">
                    Peril Type <AsteriskSymbol/>
                  </p>
                  <Select id="exampleInputPassword3" className="ms-3" classNamePrefix="ms-3" options={perilList}
                    placeholder="Select Peril"
                    // isDisabled={!claimRequestData.product_name}
                    value={claimRequestData.claimPerilName ? { label: claimRequestData.claimPerilName, value: claimRequestData.claimPerilName } : { label: "Select Peril", value: "Select Peril" }}
                    onChange={(data) => {
                      setClaimRequestData({ ...claimRequestData, 'claimPerilName': data.label, animalName: "" })
                      setSelectedAnimal(null);
                    }}
                    styles={customStyles}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                  <p className="align3Policy ms-0">Crop Name <AsteriskSymbol /></p>
                  <Select
                    id="exampleInputPassword2"
                    options={cropList}
                    placeholder="Select Crop Name"
                    value={claimRequestData.crop ? { label: claimRequestData.crop, value: claimRequestData.crop } : { label: "Select Crop Name", value: "Select Crop Name" }}
                    onChange={(data) => { setClaimRequestData({ ...claimRequestData, crop: data.label, claimRiskName: data.label, claimRiskID: data.value }) }}
                    styles={customStyles}
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12" style={{ marginTop: "1px" }}>
                  <p className="align3Policy">Alternate Contact Number</p>
                  <input
                    type="tel"
                    className="align3_dataPolicy mt-3"
                    name="tel"
                    id="tel"
                    placeholder="Enter Alternate Contact Number"
                    maxLength={10}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                      e.target.value = numericValue;
                      setClaimRequestData({ ...claimRequestData, 'claimAlternateMobileNumber': e.target.value })
                    }
                    }
                  />
                </div>
                {claimRequestData.claimPerilName === "Animal Attack" && (
                  <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="align3Policy">Animal Name <AsteriskSymbol/></p>
                    <Select
                      id="animalName"
                      className="ms-3"
                      classNamePrefix="ms-3"
                      options={animalList}
                      value={selectedAnimal ? selectedAnimal : { label: "Select Animal Name", value: "Select Animal Name" }}
                      onChange={(selectedOption) => {
                        if (selectedOption.value === "Nilgai") {
                          setShowConfirmation(true);
                          setIntimatorName("");
                        } else {
                          setSelectedAnimal(selectedOption);
                          setIntimatorName("");
                        }
                      }}
                      styles={customStyles}
                    />

                    {showConfirmation && (
                      <div className="custom-modal">
                        <div className="custom-modal-content confirmation-modal">
                          <div className="custom-modal-body">
                            <p className="confirmation-text">Are you sure it is a Nilgai attack?
                              <span
                                onClick={() => setShowConfirmation(false)}
                                className="inline-close"
                              >
                                &times;
                              </span>
                            </p>
                          </div>
                          <div className="button-container">
                            <button
                              className="custom-btn custom-btn-secondary"
                              onClick={() => {
                                setSelectedAnimal({ value: "Nilgai", label: "Nilgai" });
                                setShowConfirmation(false);
                              }}
                            >
                              Yes
                            </button>
                            <button
                              className="custom-btn custom-btn-primary"
                              onClick={() => {
                                setSelectedAnimal(null);
                                setShowConfirmation(false);
                              }}
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                  <p className="align3Policy">Claim Intimated By <AsteriskSymbol /></p>
                  <Select
                    id="claimIntimatedBy"
                    className="ms-3"
                    classNamePrefix="ms-3"
                    options={claimIntimatedByOptions}
                    styles={customStyles}
                    value={claimIntimatedBy ? claimIntimatedBy?.value : { label: "Select Claim Intimated By", value: "Select Claim Intimated By" }}
                    onChange={(selectedOption) => {
                      setClaimIntimatedBy(selectedOption.value);
                      if (selectedOption.value === "Self") {
                        setShowRelationship(false);
                        setIntimatorName(""); 
                        setRelationship("");
                      } else {
                        setShowRelationship(true);
                        setIntimatorName(""); 
                      }
                    }}
                  />
                </div>

                {showRelationship && (
                  <>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 claim-intimator-container">
                      <p className="align3Policy">Claim Intimator Name <AsteriskSymbol/></p>
                      <input
                        id="intimatorName"
                        className="claim-intimator-textarea mt-2 ms-3"
                        placeholder="Enter Claim Intimator Name"
                        maxLength={100}
                        value={intimatorName}
                        onChange={(e) => setIntimatorName(e.target.value)}
                      />
                    </div>

                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                      <p className="align3Policy">Relationship with Policyholder <AsteriskSymbol/></p>
                      <Select
                        id="relationship"
                        className="ms-3"
                        classNamePrefix="ms-3"
                        options={relationshipOptions}
                        value={relationship ? relationship?.value : { label: "Select Relationship", value: "Select Relationship" }}
                        styles={customStyles}
                        onChange={(selectedOption) => setRelationship(selectedOption.value)}
                        required
                      />
                    </div>
                  </>
                )}
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                  <p className="align6Policy">
                    Date &amp; Time of Peril Occurrence <AsteriskSymbol />
                  </p>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" style={{ marginTop: "17px", marginLeft: "10px" }}>
                      <DatePicker
                        selected={dateField}
                        className="align4_dataPolicy"
                        onChange={hanldeDatechange}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select a date"
                        maxDate={new Date()}
                        highlightDates={new Date()}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" style={{ marginTop: "17px", marginLeft: "-10px" }}>
                      <input
                        type="time"
                        className="align4_dataPolicy"
                        name="Time"
                        id="time"
                        placeholder="Select Time"
                        onChange={(e) => {
                          timeHandler(e.target.value)
                        }}
                        value={timeField}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 brief-descriptionPolicy">
                  <p className="align3Policy">Brief Description of Loss</p>
                  <textarea
                    type="text"
                    style={{
                      width: "92%",
                      height: "15px",
                      marginLeft: "0",
                      fontFamily: '"Roboto Flex", sans-serif',
                      fontWeight: 500,
                      fontSize: "15px",
                      lineHeight: "18.75px",
                      color: "rgba(0, 0, 0, 0.9)",
                      padding: "1px",
                      paddingBottom: "5px",
                      border: "none",
                      outline: "none",
                      borderBottom: "1px solid #D2D2E4",
                      marginTop: "5px",
                      marginBottom: "5px",
                      height: "28px", // Set the fixed height of the textarea
                      maxHeight: "30px", // Set the maximum height of the textarea
                      minHeight: "28px",
                      overflow: "auto", // Add scrollbars when content exceeds the maximum height
                      //resize: "" // Disable manual resizing
                    }}
                    className="align5_dataPolicy textarea_descriptionPolicy ms-3"
                    name="Brief Description about Loss"
                    id="Description"
                    placeholder="Enter Description here"
                    // defaultValue={""}
                    onChange={(e) => {
                      const maxLength = 500;
                      const currentValue = e.target.value;
                      if (currentValue.length > maxLength) {
                        e.target.value = currentValue.slice(0, maxLength);
                      }
                      setClaimRequestData({ ...claimRequestData, 'claimDescriptionofLoss': e.target.value })
                    }}
                  />
                </div>
                {/* <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <p className="align3Policy">
                    Calamity
                  </p>
                  <Select id="exampleInputPassword3" className="ms-3" classNamePrefix="ms-3" options={calamityNames}
                      placeholder="Select the Calamity"
                      value={claimRequestData.claimType ? { label: calamityLabel, value: claimRequestData.claimType } : { label: "Select the Calamity", value: "Select the Calamity" }}
                      onChange={(data) => { setClaimRequestData({ ...claimRequestData, claimType: data.value }); setCalamityLabel(data.label) }}
                      styles={customStyles}
                  />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12" style={{ marginTop: "13px" }}>
                  <p className="align3Policy">Estimated Claim Amount</p>
                  <input
                    type="text"
                    className="align3_dataPolicy mt-3"
                    name="Claim Amount"
                    id="claim_amount"
                    placeholder="Enter Estimated Claim Amount"
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                      e.target.value = numericValue;
                      setClaimRequestData({ ...claimRequestData, 'claimEstimatedAmount': e.target.value })
                    }
                    }
                  />
                </div> */}
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                  <p className="align3Policy">Attachment Type </p>
                  {/* <select name="align3_dataPolicy" className="align3_dataPolicy" style={{ marginLeft: "0px", marginTop: "5px" }} onChange={(e) => {
                    setAttachmentType(e.target.value)
                    setClaimRequestData({ ...claimRequestData, 'claimAttachmentType': e.target.value })
                    // alert(e.target.value)
                    if (e.target.value === "farm_Photo_Video") {
                      setvalidtype(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
                    }
                    else if (e.target.value === "claim_form") {
                      setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                    }
                    else if (e.target.value === "other") {
                      setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                    }
                  }
                  }>
                    <option value="farm_Photo_Video">Farm Photo and Video</option>
                    <option value="claim_form">Claim Form</option>
                    <option value="other">Other</option>
                  </select> */}
                  <Select id="exampleInputPassword3" options={[{ label: "Farm Photo and Video", value: "farm_Photo_Video" }, { label: "Claim Form", value: "claim_form" }, { label: "Other", value: "other" }]}
                    placeholder="Select Attachment Type"
                    // isDisabled={!claimRequestData.product_name}
                    value={claimRequestData.claimAttachmentType ? { label: claimRequestData.claimAttachmentType.label } : null}
                    onChange={(data) => {
                      setClaimRequestData({ ...claimRequestData, claimAttachmentType: data });
                      setAddedFiles([])
                      if (data?.value === "farm_Photo_Video") {
                        setvalidtype(['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska'])
                      }
                      else if (data?.value === "claim_form") {
                        setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                      }
                      else if (data?.value === "other") {
                        setvalidtype(['text/csv', 'image/jpeg', 'image/png', 'text/plain', 'image/gif', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/tiff', 'video/ogg', 'video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/x-matroska', 'application/pdf', 'application/vnd.ms-excel', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/rtf', 'application/vnd.oasis.opendocument.text', 'application/rtf', 'application/vnd.oasis.opendocument.spreadsheet'])
                      }
                    }}
                    styles={customStyles}
                    isClearable
                  />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12">
                  <p className="align3Policy">Transaction ID <AsteriskSymbol /></p>
                  <input
                    type="tran id"
                    className="align3_dataPolicy mt-3"
                    name="Transaction ID"
                    id="transaction"
                    placeholder="Enter transaction id"
                    maxLength={20}
                    onChange={(e) => {
                      const value=e.target.value.trim()
                      setClaimRequestData({ ...claimRequestData, tranId: value })
                    }
                    }
                  />
                </div>
                {
                  claimRequestData.claimAttachmentType && (
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 mt-3">
                      <p className="align3Policy" style={{ marginTop: "5px" }}>Attachment</p>
                      <div className="hoverPolicy">
                        <label for="fileInput">
                          <input type="file" id="fileInput" className="w-100" accept="image/*,video/*" hidden onChange={() => uploadFile()} />
                          <p className="align6_dataPolicy w-100">
                            <span className="plusPolicy" style={{ marginLeft: "2px" }} >+</span>
                            <span className="textPolicy" style={{ marginLeft: "0px" }} > Upload Proof of Loss</span>
                          </p>
                        </label>
                        {
                          isFileLoading && (
                            <span className="spinner-border ms-4" role="status">
                              <span className="sr-only">Loading...</span>
                            </span>
                          )
                        }
                        {/* <form>
                                                    <input type="file" id="fileInput" name="fileInput"/>
                                                    <button type="button" id="uploadButton">Upload</button>
                                                </form> */}
                      </div>
                      <div className="align5Policy" style={{ marginLeft: "18px" }}>File Size can not be more than 50 MB</div>
                    </div>
                  )
                }

                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 brief_descriptionPolicy">
                  {
                    addedFiles && addedFiles.length > 0 && (
                      <>
                        <br></br>
                        <p className="align3Policy" style={{ marginTop: "-16px" }}>Attached Files</p>
                        <div className="attached_file_alignPolicy"
                          style={{
                            height: '100px', // set the desired height of the div
                            width: "25%",
                            //overflow: 'auto', // this will add scrollbars inside the div
                            // border: '1px solid #ccc',
                            marginTop: "-5px",
                            padding: '10px',
                            maxHeight: "110px", // Set the maximum height of the textarea
                            minHeight: "100px",
                            width: "250px",
                            minWidth: "12%",
                            maxWidth: "30%",
                            overflow: "auto", // Add scrollbars when content exceeds the maximum height
                            resize: "auto"
                          }}
                        >
                          <div
                            style={{
                              // Add your content styles here
                              minHeight: '30px', // ensures the content is taller than the container
                            }}
                          >

                            {
                              addedFiles.map(file => (
                                <div className="align_4_dataPolicy deletePolicy">
                                  <span className="hoverPolicy">{file.name}</span>
                                  <span className="marginPolicy hoverPolicy" onClick={() => { setAddedFiles(addedFiles.filter(list => list.id !== file.id)); setfileSize(fileSize - Number((file.size / (1024 * 1024)).toFixed(2))); }}>
                                    <img
                                      src="../kshemaImages/delete_symbol.png"
                                      alt="delete"
                                      height="18px"
                                      width="auto"
                                    />
                                  </span>
                                </div>
                              ))
                            }
                            {/* Add more content here */}
                          </div>
                        </div>
                        {/* <p className="align1">Attached Files</p>
                                                    {
                                                        addedFiles.map(file => (
                                                        <div className="align_4_data delete">
                                                            <span className="hover">{file.name}</span>
                                                            <span className="margin hover" onClick={() => setAddedFiles(addedFiles.filter(list => list.id !== file.id))}>
                                                                <img
                                                                    src="../kshemaImages/delete_symbol.png"
                                                                    alt="delete"
                                                                    height="18px"
                                                                    width="auto"
                                                                />
                                                            </span>
                                                        </div>                                   
                                                        ))
                                                    } */}
                      </>
                    )
                  }
                </div>
              </div>
              <div className="buttonsPolicy" style={{ marginTop: "90px" }}>
                <button className="backPolicy" onClick={() => {
                  setShowRadioSearch(false);
                  setRaiseclaim(null);
                  setClaimWithoutPolicyPage(false);
                  setOpenDropDown(false)
                }}>Back</button>
                <button className="btn btn-success p-2 px-4 me-5 submitPolicy" disabled={!claimRequestData.claimPerilName || !claimRequestData.crop || !claimRequestData.tranId || !dateField || !timeField || claimDone == true || (claimRequestData.claimPerilName === "Animal Attack" && !selectedAnimal) || !claimIntimatedBy || isDisabled} onClick={() => onRaiseclaim()}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        //onHide={() => setModalShow(false)}
        backdrop="static"
      >
        <Modal.Body>
          <main>
            <div className="vertical-alignment">
              <div className="main-box text-center">
                <a className="center">
                  <img src="../kshemaImages/Star.png" alt="Success" width="132px" height="132px" className="center" />
                </a>
                <p className="claim_success">Claim Filed Successfully</p>
                <p className="claim_description">We have successfully Filed your Claim,<br />
                  This is Your Claim ID: <b>{claimID}</b></p>
                <div className="hover">
                  <p className="submit-box center" onClick={() => { setModalShow(false); setShowRadioSearch(false); setClaimWithoutPolicyPage(false) }}>OK</p></div>
              </div>
            </div>
          </main>
        </Modal.Body>
        {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer> */}
      </Modal>
    </section>
  )
}

export default ClaimWithoutPolicy
